import { useMemo, useRef, useState } from 'react';

import Typo from '@/components/Typography/Typo';
import { CUSTOMER_ANONYMOUS } from '@/configs/reserved-word';
import useColor from '@/hooks/domain/useColor';
import useFixed from '@/hooks/pure/useFixed';
import useDetailModalStore, {
  DETAIL_MODAL_TYPE,
} from '@/stores/pure/DetailModalStore';
import { EllipsisDiv } from '@/styles/style';

import FeedbackCustomerPreview from '../../FeedbackDetail/FeedbackPreview/FeedbackCustomerPreview';

type Props = {
  name?: string;
  alias?: string;
};

const CustomerRowItem = ({ name, alias }: Props) => {
  const color = useColor();
  const ref = useRef(null);
  const timeout = useRef<NodeJS.Timer | null>(null);
  const setNewModal = useDetailModalStore((state) => state.setNewModal);
  const [previewOpen, setPreviewOpen] = useState(false);

  const customer_name = useMemo(() => {
    return name || CUSTOMER_ANONYMOUS;
  }, [name]);

  const pos = useFixed(ref, {
    reflect: {
      x: true,
      y: true,
    },
    offset: {
      y: 0,
    },
  });

  const handleMouseEnter = () => {
    timeout.current = setTimeout(() => {
      setPreviewOpen(true);
    }, 300);
  };

  const handleMouseLeave = () => {
    setPreviewOpen(false);
    if (!timeout.current) return;
    clearTimeout(timeout.current);
  };

  return (
    <>
      <EllipsisDiv
        ref={ref}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: 'pointer', paddingLeft: 8 }}
        onClick={() =>
          alias &&
          setNewModal({
            alias,
            type: DETAIL_MODAL_TYPE.CUSTOMER,
            idx: 0,
          })
        }
      >
        <Typo type="label3" color={color.gray700}>
          {customer_name}
        </Typo>
      </EllipsisDiv>
      {previewOpen && alias && (
        <FeedbackCustomerPreview alias={alias} name={customer_name} pos={pos} />
      )}
    </>
  );
};

export default CustomerRowItem;
